import { OrderModel } from 'modules/Orders/models/order.model';
import { getOrderSumWithoutDiscount } from './getOrderSumWithoutDiscount';

export const getOrderSum: (order: OrderModel) => number = order => {
  return getOrderSumWithoutDiscount(order) - order.basket.customerData.discountAmount;
};
